import { render } from "./PageAddUsers.vue?vue&type=template&id=451cd738&scoped=true"
import script from "./PageAddUsers.vue?vue&type=script&lang=js"
export * from "./PageAddUsers.vue?vue&type=script&lang=js"

import "./PageAddUsers.vue?vue&type=style&index=0&id=451cd738&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451cd738"]])

export default __exports__